<ng-container [ngSwitch]="options.matType">
  <button
    *ngSwitchCase="'mat-raised-button'"
    mat-raised-button
    [type]="options.type"
    [color]="options.buttonColor"
    [class.active]="options.active"
    [class.fullWidth]="options.fullWidth"
    [ngClass]="options.customClass"
    [disabled]="options.active || options.disabled"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>

  <button
    *ngSwitchCase="'mat-stroked-button'"
    mat-stroked-button
    [type]="options.type"
    [color]="options.buttonColor"
    [class.active]="options.active"
    [class.fullWidth]="options.fullWidth"
    [ngClass]="options.customClass"
    [disabled]="options.active || options.disabled"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>

  <button
    *ngSwitchCase="'mat-flat-button'"
    mat-flat-button
    [type]="options.type"
    [color]="options.buttonColor"
    [class.active]="options.active"
    [class.fullWidth]="options.fullWidth"
    [ngClass]="options.customClass"
    [disabled]="options.active || options.disabled"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>

  <button
    *ngSwitchDefault
    mat-button
    [type]="options.type"
    [color]="options.buttonColor"
    [class.active]="options.active"
    [class.fullWidth]="options.fullWidth"
    [ngClass]="options.customClass"
    [disabled]="options.active || options.disabled"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
</ng-container>

<ng-template #buttonContent>
  <ng-container *ngIf="options.buttonIcon">
    <mat-icon
      [ngClass]="options.buttonIcon.customClass"
      [fontSet]="options.buttonIcon.fontSet"
      [fontIcon]="options.buttonIcon.fontIcon"
      [color]="options.buttonIcon.color"
      [svgIcon]="options.buttonIcon.svgIcon"
      [inline]="options.buttonIcon.inline"
    >
      {{ options.buttonIcon.fontSet ? '' : options.buttonIcon.fontIcon }}
    </mat-icon>
  </ng-container>

  <span>{{ options.text | translate }}</span>

  <mat-progress-bar
    class="bar"
    *ngIf="options.active && !options.disabled"
    [color]="options.barColor"
    [mode]="options.mode"
    [value]="options.value"
  >
  </mat-progress-bar>
</ng-template>
